// Module
var code = "<cu-app> <cu-app-nav id=\"sticky-header\"> <top-navigation-refreshed></top-navigation-refreshed> </cu-app-nav> <cu-app-body class=\"curalate-app-body\"> <div ui-view=\"\" class=\"flex-tall cu-h-100 cu-w-100\"></div> </cu-app-body> </cu-app> ";
// Exports
module.exports = code;